export default __webpack_public_path__ + "cd837d3f0e3cccb5df21e05646d0677e.png";